<template>
    <div id="registerView" v-loading="disabled"  element-loading-text="注册信息提交中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="left">
            <img
                src="~assets/images/common/logo.png"
                class="logo"
                alt=""
                @click="enterIndex"
            />
            <img
                src="~assets/images/common/registerBackImg.jpg"
                class="registerBackImg"
                alt=""
            />
        </div>
        <div class="registerContent">
            <div class="registerForm">
                <h4>用户注册</h4>
                <el-form
                    ref="registerForm"
                    :model="registerForm"
                    label-width="130px"
                    label-position="left"
                    :rules="rules"
                    status-icon
                    size="medium"
                >
                    <el-form-item label="姓名：" prop="userName">
                        <el-input
                            v-model="registerForm.userName"
                            :disabled="disabled"
                            placeholder="请输入姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号：" prop="idNumber">
                        <el-input
                            v-model="registerForm.idNumber"
                            :disabled="disabled"
                            placeholder="请输入身份证号"
                        ></el-input>
                        <div style="color:#606266;font-size: 13px;line-height: 26px;">请认真检查输入或复制的身份证号正确，不要有空格、全角字符或其他字符存在</div>
                    </el-form-item>
                    <el-form-item label="姓名：" prop="userName1">
                        <el-input
                            v-model="registerForm.userName1"
                            :disabled="disabled"
                            placeholder="请输入姓名"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="身份证号：" prop="idNumber1">
                        <el-input
                            v-model="registerForm.idNumber1"
                            :disabled="disabled"
                            placeholder="请输入身份证号"
                        ></el-input>
                        <div style="color:#606266;font-size: 13px;line-height: 26px;">请认真检查输入或复制的身份证号正确，不要有空格、全角字符或其他字符存在</div>
                    </el-form-item>
                    <el-form-item label="性别：" prop="sex">
                        <el-radio-group v-model="registerForm.sex"  :disabled="disabled">
                            <el-radio label="0">男</el-radio>
                            <el-radio label="1">女</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="登陆密码：" prop="password">
                        <el-input
                            v-model="registerForm.password"
                            type="password"
                            :disabled="disabled"
                            placeholder="请输入密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="重复密码：" prop="comfirePass">
                        <el-input
                            v-model="registerForm.comfirePass"
                            type="password"
                            :disabled="disabled"
                            placeholder="请输入重复密码"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="岗位名称：" prop="postName">
                        <el-select
                            v-model="registerForm.postName"
                            placeholder="请选择岗位"
                            style="width: 100%"
                            :disabled="disabled"
                        >
                            <el-option
                                v-for="item in postNameOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                        <div style="color:#606266;font-size: 13px;line-height: 26px;">如果有多个岗位证书，登录系统后，点击页面右上角头像图标--个人信息--岗位证书，添加岗位证书。请认真检查输入或复制的岗位证书编号正确，不要有空格、全角字符或其他字符存在</div>
                    </el-form-item>
                    <el-form-item label="岗位证书编号：" prop="postCertCode">
                        <el-input
                            v-model="registerForm.postCertCode"
                            :disabled="disabled"
                            placeholder="请输入岗位证书编号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="岗位证书编号：" prop="postCertCode1">
                        <el-input
                            v-model="registerForm.postCertCode1"
                            :disabled="disabled"
                            placeholder="请再次输入岗位证书编号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="手机：" prop="mobile">
                        <el-input
                            v-model="registerForm.mobile"
                            :disabled="disabled"
                            placeholder="请输入手机号"
                        ></el-input>
                    </el-form-item>
                    <el-form-item prop="veriCode" label="短信验证码：">
                        <el-input placeholder="请输入短信验证码" v-model="registerForm.veriCode">
                            <span slot="append" style="cursor: pointer;" @click="sendSmsCode" v-if="!countDown">{{
                                countDown > 0 ? `${countDown}秒后重新发送` : '发送短信验证码' }}</span>
                            <span slot="append" style="cursor: not-allowed; color: #999;" v-else>{{ countDown
                                }}秒后重新发送</span>
                        </el-input>
                        <span style="color:red;font-size: 12px;">{{ msg }}</span>
                    </el-form-item>
                    <el-form-item label="邮箱：" prop="email">
                        <el-input
                            v-model="registerForm.email"
                            :disabled="disabled"
                            placeholder="请输入邮箱"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="单位名称：" prop="businessName">
                        <el-input
                            v-model="registerForm.businessName"
                            :disabled="disabled"
                            placeholder="请输入单位名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="是否服兵役？" prop="isFby">
                        <el-select
                            v-model="registerForm.isFby"
                            placeholder="请选择"
                            style="width: 100%"
                            :disabled="disabled"
                            @change="isFbyChange"
                        >
                            <el-option key="0" label="否" value="0">
                            </el-option>
                            <el-option key="1" label="是" value="1">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="服役地点：" prop="fyLocation" v-if="registerForm.isFby == '1'">
                        <el-input
                            v-model="registerForm.fyLocation"
                            :disabled="disabled"
                            placeholder="请输入服役地点"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="国企工作经历？" prop="isGqdwjl">
                        <el-select
                            v-model="registerForm.isGqdwjl"
                            placeholder="请选择"
                            style="width: 100%"
                            :disabled="disabled"
                            @change="isGqdwjlChange"
                        >
                        <el-option key="0" label="否" value="0">
                            </el-option>
                            <el-option key="1" label="是" value="1">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="国企单位名称：" prop="gqUnitName" v-if="registerForm.isGqdwjl == '1'">
                        <el-input
                            v-model="registerForm.gqUnitName"
                            :disabled="disabled"
                            placeholder="请输入国企单位名称"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="转行建筑业？" prop="isZhjzy">
                        <el-select
                            v-model="registerForm.isZhjzy"
                            placeholder="请选择"
                            style="width: 100%"
                            :disabled="disabled"
                        >
                        <el-option key="0" label="否" value="0">
                            </el-option>
                            <el-option key="1" label="是" value="1">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <div
                            class="register_btn"
                            @click="handleRegister('registerForm')"
                        >
                            注册
                        </div>
                    </el-form-item>
                    <!-- <el-form-item
                        class="agreement_item"
                        style="text-align: center"
                    >
                        <el-checkbox v-model="isRead">我已同意</el-checkbox>
                        <span class="agreement">《注册协议》</span>
                    </el-form-item> -->
                </el-form>
                <!-- <div style="font-size:16px;">
                    说明：请您输入您在获得岗位证书时使用的姓名和身份证号码。输入的姓名和身份证号与系统匹配后才可以完成注册。<br>
                    注册中如果身份证无法通过验证，请联系证书发放单位，确认更新个人信息。更新后，再注册学习。<br>
                    如果有多个岗位证书，登录系统后，点击页面右上角头像图标--个人信息--岗位证书，添加岗位证书。<br>
                    <span style="color:#ff0000;">核验未通过的证书请与所属住建局联系核验.</span>
                    <span style="color:#ff0000;font-size:22px;">提示证书不存在或其他信息不存在时，请认真检查输入或复制的内容正确，不要有空格、全角字符或其他字符存在</span>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import {
    isvalidPhone,
    isvalidPass,
    isvalidEmail,
    isvalidUsername,
    isIdentityId,
} from "@/utils/validate.js";
import { checkIdNumber, checkName, getDictValues, register } from "@/api/register";
import { sendVeriCode } from "@/api/smsCode"
export default {
    name: "register",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else if (!isvalidPass(value)) {
                callback(
                    new Error(
                        "密码以字母开头 长度在6~12之间 只能包含字母、数字和下划线"
                    )
                );
            } else {
                if (this.registerForm.repassword !== "") {
                    this.$refs.registerForm.validateField("comfirePass");
                }
                callback();
            }
        };

        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入确认密码"));
            } else if (value !== this.registerForm.password) {
                callback(new Error("两次输入密码不一致！"));
            } else {
                callback();
            }
        };
        var validateUserName = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入姓名"));
            } else if (value !== this.registerForm.userName) {
                callback(new Error("两次输入姓名不一致！"));
            } else {
                callback();
            }
        };
        var checkPostCertCode1 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入岗位证书编号"));
            } else if (value !== this.registerForm.postCertCode) {
                callback(new Error("两次输入岗位证书编号不一致！"));
            } else {
                callback();
            }
        };
        var validPhone = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入手机号码"));
            } else if (!isvalidPhone(value)) {
                callback(new Error("请填写正确的手机号码"));
            } else {
                callback();
            }
        };
        var checkIdentitytionId = (rule, value, callback) => {
            var errorMsg = isIdentityId(value);
            if (errorMsg != "") {
                callback(new Error(errorMsg));
            } else {
                checkIdNumber(value)
                    .then((response) => {
                        if (!response.success) {
                            callback(new Error("该身份证号已存在！"));
                        } else {
                            callback();
                        }
                    })
                    .catch((err) => {
                        alert(err);
                    });
            }
        };
        var checkIdentitytionId1 = (rule, value, callback) => {
            var errorMsg = isIdentityId(value);
            if (errorMsg != "") {
                callback(new Error(errorMsg));
            } else {
                checkIdNumber(value)
                    .then((response) => {
                        if (!response.success) {
                            callback(new Error("该身份证号已存在！"));
                        } else {
                            if (value !== this.registerForm.idNumber) {
                                callback(new Error("两次输入身份证号不一致！"));
                            }
                            callback();
                        }
                    })
                    .catch((err) => {
                        alert(err);
                    });
            }
        };
        var validUsername = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入用户名"));
            } else if (!isvalidUsername(value)) {
                callback(
                    new Error(
                        "用户名要求数字、字母、下划线的组合 数字和字母必须存在 长度为8-15个字符"
                    )
                );
            } else {
                checkName(value)
                    .then((response) => {
                        if (!response.success) {
                            callback(new Error("该名称已经被使用!"));
                        } else {
                            callback();
                        }
                    })
                    .catch((err) => {
                        alert(err);
                    });
            }
        };
        var validEmail = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入邮箱"));
            } else if (!isvalidEmail(value)) {
                callback(new Error("请输入正确的邮箱"));
            } else {
                callback();
            }
        };
        return {
            loading:false,
            disabled: false,
            postNameOptions: [],
            registerForm: {
                showName:"",//用户名
                userName: "",//姓名
                userName1: "",//姓名
                sex: "",//性别
                password: "", //密码
                comfirePass: "", //重复密码
                mobile: "", //手机号
                veriCode:"",//短信验证码
                email: "", //邮箱
                idNumber: "", //身份证号
                idNumber1: "", //身份证号
                postName: "", //岗位名称
                postCertCode: "", //岗位证书编号
                postCertCode1:"",
                businessName:"",
                isFby:"",//是否服兵役
                fyLocation:"",//服役地点
                isGqdwjl:"",//是否国企单位经历
                gqUnitName: "", //国企单位名称
                isZhjzy:""//是否转行建筑业
            },
            rules: {
                showName: [
                    {
                        required: true,
                        validator: validUsername,
                        trigget: "blur",
                    },
                ],
                userName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                userName1: [{ required: true, validator: validateUserName, trigger: "blur" }],
                sex: [{ required: true, message: "请选择性别", trigger: "change" }],
                password: [
                    {
                        required: true,
                        validator: validatePass,
                        trigget: "blur",
                    },
                ],
                comfirePass: [
                    {
                        required: true,
                        validator: validatePass2,
                        trigget: "blur",
                    },
                ],
                mobile: [
                    { required: true, validator: validPhone, trigger: "blur" },
                ],
                veriCode: [
                    {
                        required: true,
                        message: "请输入短信验证码",
                        trigger: "blur"
                    },
                    {
                        len: 6,
                        message: "验证码长度为6位",
                        trigger: "blur"
                    }
                ],
                email: [
                    { required: true, validator: validEmail, trigger: "blur" },
                ],
                businessName: [
                    { required: true, message: "请选择单位名称", trigger: "blur" },
                ],
                idNumber: [
                    {
                        required: true,
                        validator: checkIdentitytionId,
                        trigger: "blur",
                    },
                ],
                idNumber1: [
                    {
                        required: true,
                        validator: checkIdentitytionId1,
                        trigger: "blur",
                    },
                ],
                postName: [
                    {
                        required: true,
                        message: "请选择岗位名称",
                        trigger: "change",
                    },
                ],
                postCertCode: [
                    {
                        required: true,
                        message: "请输入岗位证书编号",
                        trigger: "blur",
                    },
                ],
                postCertCode1:[
                    {
                        required: true,
                        validator: checkPostCertCode1,
                        trigger: "blur",
                    },
                ],
                isFby: [
                    {
                        required: true,
                        message: "请选择是否服兵役",
                        trigger: "change",
                    },
                ],
                fyLocation: [
                    {
                        required: true,
                        message: "请输入服役地点",
                        trigger: "blur",
                    },
                ],
                isGqdwjl: [
                    {
                        required: true,
                        message: "请选择国企工作经历",
                        trigger: "change",
                    },
                ],
                gqUnitName: [
                    {
                        required: true,
                        message: "请输入国企单位名称",
                        trigger: "blur",
                    },
                ],
                isZhjzy: [
                    {
                        required: true,
                        message: "请选择是否转行建筑业",
                        trigger: "change",
                    },
                ],
            },
            msg: '',
            countDown:0,
        };
    },
    mounted() {
        let that = this;
        this.toggleHeaderAndFooter("none");
        this.setHeight();
        //浏览器窗口变化 -- 容器重新赋高度
        window.addEventListener("resize", function () {
            that.setHeight();
        });
        this.fetchValues("post_name_opts");
    },
    beforeDestroy() {
        this.toggleHeaderAndFooter("block");
    },
    methods: {
        // 发送短信验证码
        async sendSmsCode() {
            // 如果正在倒计时，不执行操作
            if (this.countDown > 0) {
                return;
            }

            // if (!this.registerForm.showName) {
            //     this.$message.error("请输入用户名");
            //     return;
            // }

            if (!this.registerForm.mobile) {
                this.$message.error("请输入手机号");
                return;
            }

            // 验证手机号格式
            if (!isvalidPhone(this.registerForm.mobile)) {
                this.$message.error("请填写正确的手机号码");
                return;
            }


            // 立即开始倒计时
            this.countDown = 60; // 假设倒计时60秒，可根据需求调整
            this.timer = setInterval(() => {
                this.countDown--;
                if (this.countDown <= 0) {
                    clearInterval(this.timer);
                    this.countDown = 0;
                }
            }, 1000);

            try {
                const { errorCode, msg } = await sendVeriCode({
                    username: this.registerForm.userName,
                    smsType: 'register_bus_sms',
                    phoneNumber: this.registerForm.mobile
                });

                if (errorCode === '2000') {
                    this.$message.success("验证码发送成功");
                    this.msg = msg;
                } else {
                    // 发送失败，清除计时器并重置倒计时
                    clearInterval(this.timer);
                    this.countDown = 0;
                    this.$message.error(msg || "验证码发送失败");
                }
            } catch (error) {
                // 捕获请求异常，同样清除计时器
                clearInterval(this.timer);
                this.countDown = 0;
                console.error("发送验证码失败:", error);
            }
        },
        //注册
        handleRegister(formName) {
            this.disabled = true;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    this.registerForm.showName = this.registerForm.idNumber
                    register(this.registerForm).then((res) => {
                        if (res.errorCode === "2000") {
                            this.$refs["registerForm"].resetFields();
                            this.$message({
                                message: "注册成功",
                                type: "success",
                            });
                            setTimeout(() => {
                                this.$router.push("/pcViews/login");
                            }, 1500);
                        } else {
                            this.disabled = false;
                            this.$message({
                                message: res.msg,
                                type: "error",
                            });
                        }
                    });
                }else{
                    this.disabled = false;
                }
            });
        },
        isFbyChange(val){
            if(val == '0'){
                this.registerForm.fyLocation = ''
            }
        },
        isGqdwjlChange(val){
            if(val == '0'){
                this.registerForm.gqUnitName = ''
            }
        },
        //查询岗位名称分类
        fetchValues(type) {
            getDictValues(type).then((res) => {
                const { body, success } = res;
                if (success) {
                    this.postNameOptions = body.data;
                }
            });
        },
        //进入首页
        enterIndex() {
            this.$router.push("/");
        },
        //容器赋高度
        setHeight() {
            let registerView = document.querySelector("#registerView");
            registerView.style.height =
                document.documentElement.clientHeight + "px";
        },
        //显示、隐藏头部底部
        toggleHeaderAndFooter(displayStr) {
            let header = document.querySelector(".header");
            let footer = document.querySelector(".footer");
            header.style.display = displayStr;
            footer.style.display = displayStr;
        },
    },
};
</script>


<style>
.w48 {
    width: 48%;
}

.registerForm .el-upload {
    width: 100%;
}

.registerForm .avatar-uploader:hover {
    border-color: #409eff;
}
.registerForm .avatar-uploader {
    color: #606266;
    height: 36px;
    line-height: 36px;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    text-align: center;
}
.registerForm .el-form-item__label {
    text-align: justify;
    text-align-last: justify;
}
</style>
<style lang="less" scoped>
.agreement {
    color: #de0000;
}
.register_btn {
    margin: 0 auto;
    height: 50px;
    line-height: 50px;
    text-align: center;
    font-size: 20px;
    color: #fff;
    width: 296px;
    border-radius: 25px;
    cursor: pointer;
    background: #133d93;
}
.uploadFile {
    font-size: 14px;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 36px;
    width: 100px;
    color: #606266;
    cursor: pointer;
    i {
        margin-right: 6px;
        font-size: 20px;
        color: #133d93;
    }
}
.idPicture {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
#registerView {
    min-width: 1200px;
    display: flex;
    flex-direction: row;
    overflow: hidden;
    .left {
        width: 50%;
        height: 100%;
        position: relative;
        .registerBackImg {
            position: absolute;
            left: 50%;
            bottom: 0;
            z-index: 12;
            transform: translateX(-50%);
            width: 100%;
        }
        .logo {
            position: absolute;
            left: 66px;
            top: 58px;
            z-index: 13;
            height: 96px;
            cursor: pointer;
        }
    }
    .registerContent {
        width: 50%;
        height: 100%;
        overflow-y: auto;
        background: #f9f9f9;
        display: flex;
        align-items: center;
        flex-direction: column;
        .registerForm {
            margin: 0 auto;
            width: 590px;
            padding-bottom: 20px;
            > h4 {
                margin: 50px 0;
                text-align: center;
                font-size: 25px;
                font-family: "Microsoft YaHei";
                color: rgb(19, 61, 147);
                font-weight: bold;
                line-height: 1.44;
            }
        }
    }
}
</style>
